import { Component } from '@angular/core';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { Router, RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-business-domains',
    imports: [MatTabsModule, RouterOutlet],
    templateUrl: './business-domains.component.html',
    styleUrl: './business-domains.component.scss',
    standalone: true,
})
export class BusinessDomainsComponent {
    protected selectedTabIndex = 0;

    public constructor(private readonly router: Router) {
        // Set initial tab based on current route
        if (this.router.url.includes('/create')) {
            this.selectedTabIndex = 1;
        }
    }

    protected onTabChange(event: MatTabChangeEvent): void {
        if (event.index === 0) {
            // Navigate to list tab
            this.router.navigate(['/business-domains']);
        } else if (event.index === 1) {
            // Navigate to create tab
            this.router.navigate(['/business-domains/create']);
        }
    }
}
